import React from 'react'
import * as Icon from './icons'
import { PauseButton } from './ui'
import Vimeo from './vimeo';
import anime from 'animejs'

export class VideoPlayer extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			volume: 1,
			paused: false,
			percentage: 0,
			remainingTime: '',
			videoCompleted: false,
		};

		this.overlayRef = React.createRef()
		this.containerRef = React.createRef()

		this.handlePause = this.handlePause.bind(this);
		this.handlePlayerPause = this.handlePlayerPause.bind(this);
		this.handlePlayerPlay = this.handlePlayerPlay.bind(this);
		this.handleVolume = this.handleVolume.bind(this);
		this.getProgressData = this.getProgressData.bind(this);
		this.handleVideoEnd = this.handleVideoEnd.bind(this);
		this.runVideoExit = this.runVideoExit.bind(this);
	}

	componentDidMount() {
		document.body.classList.add("videoModal-open")
		videoInAnime( this.overlayRef.current)
	}

	runVideoExit(){
		document.body.classList.remove("videoModal-open")
		videoOutAnime( this.handleVideoEnd, this.overlayRef.current, this.containerRef.current)
	}

	handlePause(event) {
		const currentState = this.state.paused;
		this.setState({ paused: !currentState });
	}

	handlePlayerPause() {
		this.setState({ paused: true });
	}

	handlePlayerPlay() {
		this.setState({ paused: false });
	}

	handleVolume(event) {
		const currentState = this.state.volume;
		this.setState({ volume: currentState === 1 ? 0 : 1 });
	}

	getProgressData(data) {
		var currentPercentage = Math.floor( ( 100 / data.duration ) * data.seconds );
		this.setState({ percentage: currentPercentage });

		var time = data.duration - data.seconds;
		this.setState({ remainingTime: time });

		if ( data.seconds > 0 ) {
			document.querySelector('.video-wrapper').classList.remove('loading-video')
		}
	}

	handleVideoEnd(){
		this.setState({ volume: 0 });
		this.props.videoCompleted(true);
	}

	render() {
		const scanlines = this.props.scanlines ? 'scan-lines' : ''
		const videoState = this.props.videoOpen ? 'video-open': 'video-closed'
		const videoClasses = `video-scene ${videoState} ${scanlines}`
		return (
			<section className={videoClasses}>
				<div className='video-overlay' ref={this.overlayRef}>
					<div className='video-container' ref={this.containerRef}>
					   <Vimeo
					   	className='video-wrapper loading-video'
					   	video={this.props.src}
					   	controls={false}
					   	background={true}
					   	showByline={false}
					   	showTitle={false}
					   	showPortrait={false}
							autoplay={true}
							volume={this.state.volume}
							paused={this.state.paused}
							onPause={this.handlePlayerPause}
							onPlay={this.handlePlayerPlay}
							onEnd={this.runVideoExit}
							onTimeUpdate={this.getProgressData}
							ref={this.srcVideo}
							/>
						<VideoNav
							navPause={this.handlePause}
							statusPause={this.state.paused}
							navVolume={this.handleVolume}
							statusVolume={this.state.volume}
							navPercentage={this.state.percentage}
							navDuration={this.state.remainingTime}
							navCompass={this.runVideoExit}
							/>
					</div>
				</div>
			</section>
		)
	}
}

function videoInAnime( overlay ) {
	const videoIN = anime.timeline({
		autoplay: true,
		loop: false,
	})
	.add({
		targets: overlay,
		opacity: [0, 1],
		translateX: ['100%', 0],
		easing: 'easeOutQuart',
		duration: 1000,
	});
}

function videoOutAnime( handler, overlay, children ) {
	const videoOut = anime.timeline({
		autoplay: true,
		loop: false,
	})
	.add({
		targets: children,
		opacity: [1, 0],
		duration: 250,
		easing: 'easeInQuart',
	})
	.add({
		targets: overlay,
		translateX: [0, '100%'],
		easing: 'easeOutQuart',
		duration: 500,
		complete: function(anime) {
			return handler();
		}
	}, 0);
}

export class VideoNav extends React.Component {
	constructor(props) {
		super(props);
		this.navRef = React.createRef()
	}

	componentDidMount() {
		videoNavInAnime( this.navRef.current.childNodes );
	}

	render() {

		return (
			<nav className="video-nav" ref={this.navRef}>
				<VideoProgressBar
					percentage={this.props.navPercentage}
					duration={this.props.navDuration}
				/>
				<VideoVolume
					onClick={this.props.navVolume}
					statusVolume={this.props.statusVolume}
				/>
				<VideoPlayPause
					onClick={this.props.navPause}
					statusPause={this.props.statusPause}
				/>
				<VideoCompass onClick={this.props.navCompass} />
			</nav>
		)
	}
}

function videoNavInAnime( nav ) {
	const navIn = anime.timeline({
		autoplay: true,
		loop: false,
	})
	.add({
		targets: nav,
		delay: anime.stagger( 100, {grid: [1, 5], from: 'center' } ),
		easing: 'easeOutBack',
		translateY: ['200%' , 0 ],
		duration: 1000,
	}, 550)
}

export class VideoPlayPause extends React.Component {

	render() {

		return (
			<button className='videoPlayPause' onClick={this.props.onClick}>
				<PauseButton statusPause={this.props.statusPause}/>
			</button>
		)
	}
}

export class VideoVolume extends React.Component {

	render() {

		return (
			<button className='videoVolume' onClick={this.props.onClick}>
				{ this.props.statusVolume === 1
					? <Icon.IconVolume />
					: <Icon.IconMute />
				}
			</button>
		)
	}
}

export class VideoProgressBar extends React.Component {

	render() {
		const time = this.props.duration;
		const convertedTime = ('0' + Math.floor(time / 60)).slice(-2) + ':' + ('0' + Math.floor(time % 60)).slice(-2);
		return (
			<div className='videoProgressbar'>
				<progress id='progress-bar' min='0' max='100' value={this.props.percentage} ></progress>
				<div className='duration-count'>{convertedTime}</div>
			</div>
		)
	}
}

export class VideoShare extends React.Component {

	render() {

		return (
			<button className='videoShare'>
				<Icon.IconShare />
			</button>
		)
	}
}

export class VideoCaption extends React.Component {

	render() {

		return (
			<button className='videoCaption'>
				<Icon.IconCaption />
			</button>
		)
	}
}

export class VideoFullscreen extends React.Component {

	render() {

		return (
			<button className='videoFullscreen'>
				<Icon.IconFullscreen />
			</button>
		)
	}
}

export class VideoCompass extends React.Component {

	render() {

		return (
			<button className='videoExit' onClick={this.props.onClick}>
				<Icon.IconMinimize />
			</button>
		)
	}
}